import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';

export const unauthorizedGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  function getTokenFromCookie(): string | null {
    const name = 'authToken=';
    const ca = document.cookie.split(';');
    for (let c of ca) {
      c = c.trim();
      if (c.startsWith(name)) {
        return c.substring(name.length);
      }
    }
    return null;
  }
  const token = getTokenFromCookie();
  if (!token) {
    router.navigate(['/login']);
    return false;
  }
  return true;
};